export default __webpack_public_path__ + "static/media/CheckCircle(1).36af6039.svg";